import { ViewModel, View } from "binder"
import { ProductLineEditorView } from "./productLineEditor-view"
import { IProductLine } from "../IProductLine";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { Opc, OpcSelectorViewModel } from "../opcSelector-viewModel";

export class ProductLineEditorViewModel extends ViewModel implements IProductLine, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
        this.opcSelector = new OpcSelectorViewModel(this);
        this.opcSelector.onSelectionChanged = x => this.onOpcChanged(x);
    }
    GetDefaultView(): View<ViewModel> {
        return new ProductLineEditorView();
    }
    public getTypeId(): string {
        return "VM-F5A1DFDD-9CFA-43B3-859B-C0268EA21FE0"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set opcId(v: string) { this._opcId = v; } public get opcId(): string { return this._opcId; } private _opcId: string;
    public set opcSelector(v: OpcSelectorViewModel) { this._opcSelector = v; } public get opcSelector(): OpcSelectorViewModel { return this._opcSelector; } private _opcSelector: OpcSelectorViewModel;

    closePopup(result?: any) {

    }

    onOpcChanged(opc: Opc) {
        this.opcId = opc?.id;
    }

    setOpcId(id: string) {
        this.opcSelector.selectById(id);
    }

    getOpcId(): string {
        return this.opcSelector.selectedItem?.id;
    }

    async cloneTo(productLine: IProductLine) {
        productLine.id = this.id;
        productLine.name = this.name;
        productLine.comment = this.comment;
        productLine.setOpcId(this.getOpcId());
    }

    back() {
        this.closePopup(null);
    }

    async save(): Promise<void> {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت خط تولید');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت تکراری نام خط تولید وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('خط تولید با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت خط تولید', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push('نام خط تولید مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getOpcId())) {
            result.push('نام OPC مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(productLine: IProductLine): Promise<any>;
}

export class ProductLineInserter implements IServerUpdater {
    async execute(productLine: IProductLine): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ProductLineServices/CreateProductLine', {
                Name: productLine.name,
                Comment: productLine.comment,
                OpcId: productLine.getOpcId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class ProductLineUpdater implements IServerUpdater {
    async execute(productLine: IProductLine): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ProductLineServices/UpdateProductLine', {
                ProductLineId: productLine.id,
                Name: productLine.name,
                Comment: productLine.comment,
                OpcId: productLine.getOpcId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
